/**
 * Use this React component to limit access to a page based on user group membership
 * @param {*} props
 */
export const CheckAuth = (props: { groupName: string }) => {
	return null;
};
